module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-wedding-location-feb5346cc2dc4ba643b31f04c3a96861.jpg";